import { isFunction } from './validators';
export function safeInvoke(func) {
  if (isFunction(func)) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return func.apply(void 0, args);
  }
  return undefined;
}
export function invokeAll() {
  for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }
  return function () {
    for (var _i = 0, _funcs = funcs; _i < _funcs.length; _i++) {
      var func = _funcs[_i];
      if (isFunction(func)) {
        func.apply(void 0, arguments);
      }
    }
    return undefined;
  };
}